'use client';

import { useEffect, RefObject } from 'react';

interface UseScrollToStepProps {
  currentStepId: string;
  stepTopRef: RefObject<HTMLDivElement | null>;
}

/**
 * Hook to handle scrolling to top of step on step change
 */
export const useScrollToStep = ({ currentStepId, stepTopRef }: UseScrollToStepProps) => {
  useEffect(() => {
    if (!currentStepId) return;
    const rafId = requestAnimationFrame(() => {
      if (stepTopRef.current) {
        stepTopRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        const willsFormContainer = document.getElementById('willsFormContainer');
        if (willsFormContainer) {
          willsFormContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });

    // Cleanup: cancel animation frame if component unmounts or step changes
    return () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [currentStepId, stepTopRef]);
};
